<template>
  <div class="panel panel--dashboard">
    <div class="panel__menu">
    </div>
    <b-button class="mr-1 btn-sm"
      @click.stop="back">
      Back
    </b-button>
    <!-- <section class="section" v-show="protocol"> -->
    <section class="section">
      <div class="section__body">
        <div>
         Link <input :value="location+'?tid='+experiment.tid+'&eid='+experiment.eid" size="80"/>
          <div>
              Download <a href="#" @click.stop="dl(experiment, 'csv')">
                CSV
              </a>
              /
              <a href="#" @click.stop="dl(experiment, 'json')">
                JSON
              </a>
          </div>
         
        </div>
        <div class="item item--tabbed">
          <b-tabs pills content-class="item--tabbed__content" nav-wrapper-class="item--tabbed__tabs" active>
            <b-tab title="Temperature">
              <div style="width:800px;height:640px;">
                <TemperatureChart ref="temperatureChart" />
              </div>
            </b-tab>
            <b-tab title="Protocol">
              <div style="width:800px;height:640px;">
                <ProtocolDetail ref="protocolDetail" :protocol="protocol" />
              </div>
            </b-tab>
            <b-tab title="AmplificationChart">
              <div style="width:800px;height:640px;">
                <AmplificationChart ref="amplificationChart" />
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

import appState from "../../lib/AppState.js";
import device from "../../lib/Device.js";
import Util from "../../lib/Util.js";
import hardwareConfig from "../../lib/HardwareConfig.js";
import TemperatureChart from '../ExperimentMonitor/TemperatureChart.vue'
import AmplificationChart from '../ExperimentMonitor/AmplificationChart.vue'
import ProtocolDetail from '../ProtocolDetail.vue'
export default {
  name: 'TheExperimentDetail',
  components: {
    TemperatureChart,
    AmplificationChart,
    ProtocolDetail
  },
  props: {
  },
  data() {
    return {
      subs: [],
      protocol: null,
      ampChartReady: false,
      experiment:{},
      location: location.origin
    }
  },
  mounted: function () {
  },
  created: function () {
    console.log("TheExperimentDetail.created")
    device.protocol.observe((protocol)=>{
      this.protocol = protocol
    });
  },
  methods: {
    subscribe (topic, handler) {
      this.subs.push(device.subscribe(topic, handler));
    },
    onAppear (message) {
      console.log("TheExperimentDetail.onAppear message=");
      console.log(message);
      if (!this.ampChartReady) {
        this.$refs.amplificationChart.setHardwareConf(hardwareConfig);
        this.$refs.amplificationChart.setAppearanceConf(this.getAppearanceConf());
        this.ampChartReady = true;
      }
      console.log("TheExperimentDetail CLEAR!!!");
      this.$refs.amplificationChart.clear();
      this.$refs.temperatureChart.clear();
      this.experiment = message;
      if (message.g && message.g.protocol) {

        this.protocol = message.g.protocol
      }
      if (message.eid) {
        device.loadExperimentProgress(message.eid, 
        (data)=>{
          this.$refs.temperatureChart.set(data);
        }, 
        ()=>{
          appState.toast(this, "Error", "Failed to load the experiment log.");
        });
        device.loadExperimentFluo(message.eid, 
        (data)=>{
          // TODO populate progress
          console.log("TheExperimentDetail fluo setting...")
          console.log(data)
          this.$refs.amplificationChart.set(data);
        }, 
        ()=>{
          appState.toast(this, "Error", "Failed to load the experiment log.");
        });
      }
    },
    back () {
      console.log("Unsub all")
      this.subs.forEach((subId)=>{device.unsubscribe(subId)});
      appState.backPanel();

    },
    getAppearanceConf () {
      console.log("TheExperimentDetail.getAppearanceConf")
      let appearances = [];
      this.well_appearance = [];
      console.log(hardwareConfig);
      for (let w=0; w<hardwareConfig.wells.count; w++) {
        let obj = {
          v: true,
          c: Util.defaultPalette[w]
        };
        this.well_appearance.push(obj);
      }
      for (let ch=0; ch < hardwareConfig.channels.count; ch++) {
        appearances.push(this.well_appearance);
      }
      console.log(appearances)
      return appearances;

    },
    dl (experiment, fileType) {
      device.downloadExperimentLog(experiment, fileType);
    },
    title () { return "Experiment Log" }
  }
}
</script>